import { Box, Text } from '@chakra-ui/react';
import { Song, SongStatusLabel } from 'types/song';
import { AppDispatch } from 'app/store';
import { useEffect, useState } from 'react';
import { routes } from 'app/routing/routesConfig';
import { isEmptyPinSectionDismissed } from 'app/utils/helpers';
import { LeaveSongDialog } from '../Song/Collaborators/LeaveSongDialog';
import { PinnedSong } from './types';
import { PinnedSongsSectionContent } from './PinnedSongsSectionContent';
import { getSongListMenuOptions } from '../Song/SongList/utils';

export interface PinnedSongsSectionComponentProps {
  profileGuid?: string;
  songs: Song[];
  isFetching: boolean;
  dispatch: AppDispatch;
}

export const PinnedSongsSectionComponent = ({
  profileGuid,
  songs,
  isFetching,
  dispatch,
}: PinnedSongsSectionComponentProps) => {
  const [dismissed, setDissmissed] = useState(true);
  const [leaveSong, setLeaveSong] = useState<Song>();

  useEffect(() => {
    if (profileGuid) {
      setDissmissed(isEmptyPinSectionDismissed(profileGuid));
    }
  }, [profileGuid]);

  const data: PinnedSong[] = songs.map((song) => ({
    guid: song.guid,
    label: song.title,
    subLabel: SongStatusLabel[song.status],
    status: song.status,
    href: routes.song.path.replace(':guid', song.guid),
    menuOptions: getSongListMenuOptions(song, setLeaveSong, true, dispatch),
  }));

  if (dismissed && (isFetching || songs.length === 0)) {
    return null;
  }

  return (
    <Box mb={4} mr={-6} data-testid="pinned-songs-section">
      <Text as="h2" fontSize="lg" fontWeight={500}>
        Pinned Songs
      </Text>
      <PinnedSongsSectionContent
        data={data}
        isFetching={isFetching}
        setDissmissed={setDissmissed}
      />
      <LeaveSongDialog
        dispatch={dispatch}
        context="songList"
        song={leaveSong}
        open={!!leaveSong}
        onClose={() => setLeaveSong(undefined)}
      />
    </Box>
  );
};
